import { sinkingFundPayment } from "shared/sinkingFundPayment";
import { GOAL_REAL_YIELD } from "web_myplann/Goals/constants";
import { monthsUntil } from "web_myplann/Goals/Helpers/monthsUntil";

export const monthlyContribution = (
	savingsTarget: number,
	dueDate: Date | undefined | null,
	annualRate: number = GOAL_REAL_YIELD,
): number => {
	return sinkingFundPayment(
		annualRate / 12,
		monthsUntil(dueDate),
		savingsTarget,
	);
};
